import React, { useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';

import { FiX, FiPlus } from 'react-icons/fi';

import * as Yup from 'yup';

import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';

import { Form, DivLeft } from './styles';

import Input from '../../../Global/Input';
import Button from '../../../Global/Button';

import Modal from '../index';
import { api } from '../../../../services/api';

export interface IBranchForm {
  full_name: string;
  short_name: string;
  cnpj?: string;
  address?: string;
  short_address?: string;
}

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  handleBranch: () => void;
}

// No banco todas as colunas são NOT NULL: campos vazios vão como "".
export function formatBranchData(data: IBranchForm): IBranchForm {
  return {
    full_name: (data.full_name ?? '').trim(),
    short_name: (data.short_name ?? '').trim(),
    cnpj: (data.cnpj ?? '').trim(),
    address: (data.address ?? '').trim(),
    short_address: (data.short_address ?? '').trim(),
  };
}

export const branchSchema = Yup.object().shape({
  full_name: Yup.string().trim().required('Nome completo é obrigatório'),
  short_name: Yup.string().trim().required('Nome curto é obrigatório'),
});

const ModalAddBranch: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  handleBranch,
}) => {
  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: IBranchForm) => {
      try {
        formRef.current?.setErrors({});

        await branchSchema.validate(data, {
          abortEarly: false,
        });

        await api.post('/branches', formatBranchData(data));

        setIsOpen();
        handleBranch();

        addToast({
          type: 'success',
          title: 'Filial',
          description: 'Filial criada com sucesso',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        console.log(err);
        setIsOpen();
        addToast({
          type: 'error',
          title: 'Erro na criação',
          description: 'Ocorreu um erro ao criar nova filial.',
        });
      }
    },
    [handleBranch, setIsOpen, addToast],
  );

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <span>
          <div>
            <h2>Criar nova filial</h2>
            <FiPlus size={20} />
          </div>

          <FiX size={20} onClick={() => setIsOpen()} />
        </span>

        <p>Nome completo</p>
        <Input
          name="full_name"
          placeholder="Ex: Razão social completa da filial"
        />

        <p>Nome curto (aparece nas listas do PIC e da despesa)</p>
        <Input name="short_name" placeholder="Ex: Matriz" />

        <p>CNPJ</p>
        <Input name="cnpj" placeholder="Ex: 00.000.000/0000-00" />

        <p>Endereço completo</p>
        <Input
          name="address"
          placeholder="Ex: Rua, número, bairro, cidade - UF"
        />

        <p>Endereço resumido / cidade</p>
        <Input name="short_address" placeholder="Ex: Rio Verde - GO" />

        <DivLeft>
          <Button type="submit" groud={false} disabled={false} isUsed={false}>
            Salvar
          </Button>
        </DivLeft>
      </Form>
    </Modal>
  );
};

export default ModalAddBranch;
